<template>
	<router-view
	v-loading.fullscreen.lock="full_screen_loading"
	/>
</template>

<script>
import { mapState } from 'vuex'
export default {
	computed: {
		...mapState(['full_screen_loading'])
	}
}
</script>

<style>
.el-dialog__body{
	word-break:normal; /* Fixes weird default breaking from element UI */
}
</style>
